import React from "react";
import { AlibabaCloudMark } from "@/brand/ProviderLogos";

const GOOGLE_PARTNER_URL = "https://cloud.google.com/find-a-partner/partner/cloud-beaker-llc";
const PUB = process.env.PUBLIC_URL || "";

function ImgMark({ src, alt }) {
  return <img src={`${PUB}/brand/${src}`} alt={alt} className="h-7 w-auto shrink-0" loading="lazy" />;
}

const PARTNERS = [
  { name: "Google Cloud", badge: "google-partner.png", href: GOOGLE_PARTNER_URL },
  { name: "Microsoft CSP", badge: "microsoft-csp.png" },
  { mark: <AlibabaCloudMark size={28} />, name: "Alibaba Cloud", rel: "Partner" },
  { name: "AWS", badge: "aws-partner.png" },
  { name: "Cisco Meraki", badge: "ciscomeraki.png" },
  { mark: <ImgMark src="redhat.svg" alt="Red Hat" />, name: "Red Hat", rel: "Partner" },
];

function PartnerBadge({ p }) {
  if (p.badge) {
    const img = (
      <img
        src={`${PUB}/brand/${p.badge}`}
        alt={`${p.name} official partner logo`}
        className="max-h-16 w-auto object-contain"
        loading="lazy"
      />
    );
    const testId = `partner-badge-${p.name.toLowerCase().replace(/\s+/g, "-")}`;
    if (p.href) {
      return (
        <a
          href={p.href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={testId}
          className="flex items-center justify-center transition-opacity hover:opacity-80"
        >
          {img}
        </a>
      );
    }
    return (
      <div className="flex items-center justify-center" data-testid={testId}>
        {img}
      </div>
    );
  }
  const inner = (
    <>
      {p.mark}
      <div className="leading-tight">
        <div className="text-sm font-bold text-cbink">{p.name}</div>
        <div className="text-xs text-cbslate">{p.rel}</div>
      </div>
    </>
  );
  if (p.href) {
    return (
      <a
        href={p.href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="google-partner-badge"
        className="flex items-center justify-center gap-3 rounded-lg transition-opacity hover:opacity-80"
      >
        {inner}
      </a>
    );
  }
  return <div className="flex items-center justify-center gap-3">{inner}</div>;
}

export default function PartnerStrip() {
  return (
    <section className="relative z-10 -mt-8" data-testid="partner-strip">
      <div className="container-cb">
        <div className="rounded-2xl border border-border bg-white p-6 shadow-panel md:px-8">
          <p className="text-center text-[11px] font-semibold uppercase tracking-[0.2em] text-cbslate">
            Trusted Technology Partners
          </p>
          <div className="mt-5 grid grid-cols-2 items-center gap-x-4 gap-y-5 sm:grid-cols-3 lg:grid-cols-6">
            {PARTNERS.map((p) => (
              <PartnerBadge key={p.name} p={p} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
